module.exports = __webpack_public_path__ + "static/img/2014.e1202cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2014.png
// module id = p4di
// module chunks = 0